<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_user2.png"
        alt="会員情報の更新"
        width="40"
        class="mb30"
      /><br />{{ $t("registerPhone") }}
    </h2>
    <div class="account-box">
      <dl>
        <dt>{{ $t("countryCode") }}</dt>
        <dd>
          <span v-if="!$v.selectedCountryCode">
            {{
              $t(this.getMessage($v.selectedCountryCode, { name: "国コード" }))
            }}
          </span>
          <select v-model.trim="$v.selectedCountryCode.$model">
            <option disabled value="">{{ $t("chooseOption") }}</option>
            <option
              v-for="option in this.countries"
              :value="option.phone"
              :key="option.name"
            >
              {{
                option.name + " - " + option.name_en + "(" + option.phone + ")"
              }}
            </option>
          </select>
          <br />
          <span class="txt-info block">
            {{ $t("infoNationality") }}
          </span>
        </dd>
        <dt>{{ $t("phoneNumber") }}</dt>
        <dd>
          <span v-if="!$v.phone.required">
            {{ $t(this.getMessage($v.phone, { name: "電話番号" })) }}
          </span>
          <input
            type="text"
            id="phone"
            name="phone"
            placeholder="Phone number"
            v-model.trim="$v.phone.$model"
          />
          <br />
          <span class="txt-info block">
            {{ $t("infoPhone") }}
          </span>
        </dd>
      </dl>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="this.$v.$invalid && this.vaError" />
      <firebaseError :error="this.fbError" :errorCode="errorCode" />
    </p>
    <p class="txt-error center mb40" v-if="phoneError">
      {{ $t("phoneAlreadyExist") }}
    </p>
    <p class="txt-error center mb40" v-if="errorServer">
      {{ $t("errorServer") }}
    </p>
    <p class="btn-normal">
      <button id="phoneButton">{{ $t("verifyPhoneNumber") }}</button>
    </p>
  </main>
</template>

<script>
import firebase from "firebase";
import { required, numeric } from "vuelidate/lib/validators";
import countries from "@/constants/CountriesEnum";
import firebaseError from "@/error/FirebaseError";
import validationError from "@/error/ValidationError";
//const regex=helpers.regex('alpha',/^(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})$/);

export default {
  name: "AccountRegisterPhone",
  mixins: [countries],
  data() {
    return {
      phoneError: false,
      errorServer: false,
      phone: "",
      verificationId: "",
      verificationCode: "",
      selectedCountryCode: "",
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      vaError: false, //バリデーションエラー
      fbError: false, //firebaseエラー
      errorCode: "",
    };
  },
  components: {
    firebaseError,
    validationError,
  },
  validations: {
    selectedCountryCode: {
      selected: required,
    },
    phone: {
      required,
      numeric,
    },
  },
  created() {},
  mounted() {
    try {
      firebase.auth().useDeviceLanguage();
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "phoneButton",
        {
          size: "invisible",
          callback: async () => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            await this.update();
          },
          "expired-callback": () => {
            window.recaptchaVerifier.reset();
          },
        }
      );
      window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
      });
    } catch (e) {
      //console.log(e);
    }
  },
  watch: {
    phone() {
      this.phoneError = false;
      this.errorServer = false;
    },
  },
  methods: {
    async checkPhone() {
      let checkPhone = firebase.functions().httpsCallable("checkPhone");
      let res = await checkPhone({ phone: this.phone });
      return res.data;
    },
    async update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        //        const invalidFields=Object.keys(this.$v.$params).filter(fieldName=>this.$v[fieldName].$invalid);
        this.vaError = true;
        window.recaptchaVerifier.reset();
      } else {
        if (!this.phone.startsWith("0") && this.selectedCountryCode == "+81") {
          this.phone = "0" + this.phone;
        }
        //let res = await this.checkPhone();
        let res = true;
        if (res) {
          const appVerifier = window.recaptchaVerifier;
          let provider = new firebase.auth.PhoneAuthProvider();
          try {
            let verificationId = await provider.verifyPhoneNumber(
              this.selectedCountryCode + this.phone,
              appVerifier
            );
            let phone = this.phone;
            let countryCode = this.selectedCountryCode;

            this.$router.push({
              name: "AccountValidatePhoneCode",
              params: {
                verificationId: verificationId,
                phone: phone,
                countryCode: countryCode,
                newRegistration: true,
              },
            });
          } catch (error) {
            //SMS Could not be sent
            this.errorServer = true;
            window.recaptchaVerifier.reset();
          }
        } else {
          // Alert phone number already existing
          this.phoneError = true;
          window.recaptchaVerifier.reset();
        }
      }
    },
  },
};
</script>
